import React, { useEffect, useState } from "react";
import { Fragment } from "react";
import { url } from "../../Config/Config";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "../FieldComponets/Spinner";
import { useForm } from 'react-hook-form';

import { DashboardRedirectionAction, GetDashboardDataAction } from "../../Redux/Action/CommonAction";
import { setItemToStorage } from "../../utils/Helper";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";

function Dashboard() {
  const dispatch: any = useDispatch();
  const DashboardDataGet = useSelector(
    (state: any) => state.DashboardDataGetState
  );

  const horse_show_list_data = useSelector(
    (state: any) => state.UserStallFormHorseShowListState
  );

  const [dashboardCount, setDashboardCount]: any = useState('');
  const [selectedHorse, setSelectedHorse] = useState<any[]>([]);
  const {
    control,
    register,
    handleSubmit,
    reset,
    getValues,
    setValue,
    formState: { errors, isValid, isValidating },
  } = useForm({
    // resolver: yupResolver(formSchema),
    mode: 'onChange',
    defaultValues: {
      show_id: ""
    }
  });
  useEffect(() => {
    dispatch(GetDashboardDataAction({}));
  }, [dispatch]);

  useEffect(() => {
    if (!dashboardCount && DashboardDataGet?.data?.data) {
      setDashboardCount({
        users: DashboardDataGet?.data?.data?.users,
        horse_shows: DashboardDataGet?.data?.data?.horse_shows,
        inactive_users: DashboardDataGet?.data?.data?.inactive_users,
        active_users: DashboardDataGet?.data?.data?.active_users
      });
    }
   
  }, [DashboardDataGet]);

  

  const handleOnChangeHorseShow = (e: any) => {
    const selectedId = e.target.value;
    setSelectedHorse(selectedId);
    setValue("show_id", selectedId);
    dispatch(GetDashboardDataAction({ show_id: selectedId }));
  };



  useEffect(() => {
    return () => {
      dispatch(GetDashboardDataAction('RESET'));
    }
  }, [])
  return (
    <Fragment>
      {DashboardDataGet?.loading && <Spinner />}
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0 font-size-18"><FormattedMessage id="dashboard" /></h4>
                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        <Link to={'/dashboard'}><FormattedMessage id="dashboard" /></Link>
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
            <div className="row gy-4">
              <div className="col-md-6 col-lg-4 col-xl-3">
                <div className="dash-card card-1 bg-white">
                  <div className="dash-head">
                    <Link to={'/customer-management-list'}  className="dash-arrow">
                      <i className="fa fa-arrow-right" aria-hidden="true"></i>
                    </Link>
                    <h5 className="title"><FormattedMessage id="total_registered_user" /></h5>
                  </div>
                  <div className="d-flex align-items-center">
                    <div className="num">
                      {dashboardCount?.users || 0}
                    </div>
                    <i className="card-icon fa fa-user"></i>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 col-xl-3">
                <div className="dash-card card-1 bg-white">
                  <div className="dash-head">
                    <Link  onClick={() => dispatch(DashboardRedirectionAction({ 'status': '1' }))}  to={"/customer-management-list"} className="dash-arrow">
                      <i className="fa fa-arrow-right" aria-hidden="true"></i>
                    </Link>
                    <h5 className="title"><FormattedMessage id="active_users" /></h5>
                  </div>
                  <div className="d-flex align-items-center">
                    <div className="num">{dashboardCount?.active_users || 0}</div>
                    <i className="card-icon fa fa-user"></i>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 col-xl-3">
                <div className="dash-card card-1 bg-white">
                  <div className="dash-head">
                    <Link onClick={() => dispatch(DashboardRedirectionAction({ 'status': '0' }))}  to={'/customer-management-list'}  className="dash-arrow">
                      <i className="fa fa-arrow-right" aria-hidden="true"></i>
                    </Link>
                    <h5 className="title"><FormattedMessage id="inactive_users" /></h5>
                  </div>
                  <div className="d-flex align-items-center">
                    <div className="num">{dashboardCount?.inactive_users || 0}</div>
                    <i className="card-icon fa fa-user"></i>
                  </div>
                </div>
              </div>
              {/* <div className="col-md-6 col-lg-4 col-xl-3">
                <div className="dash-card card-2 bg-white">
                  <div className="dash-head">
                    <a
                      className="dash-arrow"
                      
                    >
                      <i className="fa fa-arrow-right" aria-hidden="true"></i>
                    </a>
                    <h5 className="title">Total salons</h5>
                  </div>
                  <div className="d-flex align-items-center">
                    <div className="num">
                      {dashboardCount?.horse_shows || 10}
                    </div>
                    <i className="card-icon fa fa-horse"></i>
                    
                  </div>
                </div>
              </div> */}
                {/* <div className="row gy-4 mb-4"> */}
              <div className="col-md-6 col-lg-4 col-xl-3">
                <div className="dash-card card-1 bg-white">
                  <div className="dash-head">
                    <Link onClick={() => dispatch(DashboardRedirectionAction({ 'status': '' }))}  to={'/salon-list'}  className="dash-arrow">
                      <i className="fa fa-arrow-right" aria-hidden="true"></i>
                    </Link>
                    <h5 className="title"><FormattedMessage id="total_salons" /></h5>
                  </div>
                  <div className="d-flex align-items-center">
                    <div className="num">{DashboardDataGet?.data?.data?.total_salon_users || 0}</div>
                    <i className="card-icon fa fa-calendar"></i>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 col-xl-3">
                <div className="dash-card card-1 bg-white">
                  <div className="dash-head">
                    <Link onClick={() => dispatch(DashboardRedirectionAction({ 'status': '1' }))}  to={'/salon-list'}  className="dash-arrow">
                      <i className="fa fa-arrow-right" aria-hidden="true"></i>
                    </Link>
                    <h5 className="title"><FormattedMessage id="total_active_salons" /></h5>
                  </div>
                  <div className="d-flex align-items-center">
                    <div className="num">{DashboardDataGet?.data?.data?.active_salon_users || 0}</div>
                    <i className="card-icon fa fa-calendar"></i>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 col-xl-3">
                <div className="dash-card card-1 bg-white">
                  <div className="dash-head">
                    <Link onClick={() => dispatch(DashboardRedirectionAction({ 'status': '0' }))}  to={'/salon-list'}  className="dash-arrow">
                      <i className="fa fa-arrow-right" aria-hidden="true"></i>
                    </Link>
                    <h5 className="title"><FormattedMessage id="total_inactive_salons" /></h5>
                  </div>
                  <div className="d-flex align-items-center">
                    <div className="num">{DashboardDataGet?.data?.data?.inactive_salon_users || 0}</div>
                    <i className="card-icon fa fa-calendar"></i>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 col-xl-3">
                <div className="dash-card card-1 bg-white">
                  <div className="dash-head">
                    <Link onClick={() => dispatch(DashboardRedirectionAction({ 'status': '1' }))}  to={'/service'}  className="dash-arrow">
                      <i className="fa fa-arrow-right" aria-hidden="true"></i>
                    </Link>
                    <h5 className="title"><FormattedMessage id="total_services" /></h5>
                  </div>
                  <div className="d-flex align-items-center">
                    <div className="num">{DashboardDataGet?.data?.data?.total_services || 0}</div>
                    <i className="card-icon fa fa-calendar"></i>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 col-xl-3">
                <div className="dash-card card-1 bg-white">
                  <div className="dash-head">
                    <Link onClick={() => dispatch(DashboardRedirectionAction({ 'status': '1' }))}  to={'/category'}  className="dash-arrow">
                      <i className="fa fa-arrow-right" aria-hidden="true"></i>
                    </Link>
                    <h5 className="title"><FormattedMessage id="total_categories" /></h5>
                  </div>
                  <div className="d-flex align-items-center">
                    <div className="num">{DashboardDataGet?.data?.data?.total_categories  || 0}</div>
                    <i className="card-icon fa fa-store"></i>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 col-xl-3">
                <div className="dash-card card-1 bg-white">
                  <div className="dash-head">
                    <Link   to={'/booking-list'}  className="dash-arrow">
                      <i className="fa fa-arrow-right" aria-hidden="true"></i>
                    </Link>
                    <h5 className="title"><FormattedMessage id="total_bookings_label" /></h5>
                  </div>
                  <div className="d-flex align-items-center">
                    <div className="num">{DashboardDataGet?.data?.data?.total_booking  || 0}</div>
                    <i className="card-icon fas fa-book"></i>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 col-xl-3">
                <div className="dash-card card-1 bg-white">
                  <div className="dash-head">
                    <Link onClick={() => dispatch(DashboardRedirectionAction({ 'status': '0' }))}  to={'/booking-list'}  className="dash-arrow">
                      <i className="fa fa-arrow-right" aria-hidden="true"></i>
                    </Link>
                    <h5 className="title"><FormattedMessage id="total_upcoming_bookings" /></h5>
                  </div>
                  <div className="d-flex align-items-center">
                    <div className="num">{DashboardDataGet?.data?.data?.total_upcoming_booking  || 0}</div>
                    <i className="card-icon fas fa-clipboard-list"></i>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 col-xl-3">
                <div className="dash-card card-1 bg-white">
                  <div className="dash-head">
                    <Link onClick={() => dispatch(DashboardRedirectionAction({ 'status': '1' }))}  to={'/booking-list'}  className="dash-arrow">
                      <i className="fa fa-arrow-right" aria-hidden="true"></i>
                    </Link>
                    <h5 className="title"><FormattedMessage id="total_completed_bookings" /></h5>
                  </div>
                  <div className="d-flex align-items-center">
                    <div className="num">{DashboardDataGet?.data?.data?.total_completed_booking  || 0}</div>
                    <i className="card-icon fas fa-check-circle"></i>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 col-xl-3">
                <div className="dash-card card-1 bg-white">
                  <div className="dash-head">
                    <Link onClick={() => dispatch(DashboardRedirectionAction({ 'status': '2' }))}  to={'/booking-list'}  className="dash-arrow">
                      <i className="fa fa-arrow-right" aria-hidden="true"></i>
                    </Link>
                    <h5 className="title"><FormattedMessage id="total_cancelled_bookings" /></h5>
                  </div>
                  <div className="d-flex align-items-center">
                    <div className="num">{DashboardDataGet?.data?.data?.total_cancelled_booking  || 0}</div>
                    <i className="card-icon fas fa-times-circle"></i>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 col-xl-3">
                <div className="dash-card card-1 bg-white">
                  <div className="dash-head">
                    <Link onClick={() => dispatch(DashboardRedirectionAction({ 'status': '3' }))}  to={'/booking-list'}  className="dash-arrow">
                      <i className="fa fa-arrow-right" aria-hidden="true"></i>
                    </Link>
                    <h5 className="title"><FormattedMessage id="total_no_shown_up_bookings" /></h5>
                  </div>
                  <div className="d-flex align-items-center">
                    <div className="num">{DashboardDataGet?.data?.data?.total_noshown_booking  || 0}</div>
                    <i className="card-icon fas fa-calendar-minus"></i>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 col-xl-3">
                <div className="dash-card card-1 bg-white">
                  <div className="dash-head">
                    <Link onClick={() => dispatch(DashboardRedirectionAction({ 'status': '1' }))}  to={'/booking-list'}  className="dash-arrow">
                      <i className="fa fa-arrow-right" aria-hidden="true"></i>
                    </Link>
                    <h5 className="title"><FormattedMessage id="total_earnings" /></h5>
                  </div>
                  <div className="d-flex align-items-center">
                    <div className="num">{DashboardDataGet?.data?.data?.totalRevenue  || 0}</div>
                    <i className="card-icon fas fa-euro-sign"></i>
                  </div>
                </div>
              </div>
            {/* </div> */}
            </div>
      
            {/* <div className="row gy-4">
          
            </div> */}

          </div>
        </div>
      </div >
    </Fragment >
  );
}

export default Dashboard;
